import type { Revision } from "@/queries/formality-request";
import { useMemo } from "react";

/**
 * Counts the corrections still awaiting the leader's VoBo, and indexes the
 * revisions and groups they belong to so the selector can flag them.
 *
 * A VoBo is pending when the revision requires leader approval and the
 * correction is still IN_PROCESS with `is_leader_approved === false`.
 */
export const usePendingVoBo = (revisionsRaw: Revision[]) =>
  useMemo(() => {
    const revisionIds = new Set<string>();
    const groupIds = new Set<string>();
    let count = 0;

    for (const revision of revisionsRaw) {
      if (!revision.requires_leader_approval) continue;

      for (const correction of revision.corrections ?? []) {
        if (
          correction.status === "IN_PROCESS" &&
          correction.is_leader_approved === false
        ) {
          revisionIds.add(revision.id);
          if (correction.group?.id) {
            groupIds.add(correction.group.id);
          }
          count++;
        }
      }
    }

    return {
      pendingVoBoMap: {
        revisions: revisionIds,
        groups: groupIds,
      },
      pendingVoBoCount: count,
    };
  }, [revisionsRaw]);
